import { useQuery } from 'hooks/useCustomQuery';
import getPlatformNumbers from 'API/PlatformNumber/getPlatformNumbers';

const useGetPlatformNumbers = (
    numberId,
    accountScope,
    expandedParams,
    expandedPlatformNumbersRef,
    expansionCount = 0,
) => {
    return useQuery({
        // expansionCount keys the request to the expand that asked for it: the
        // detail grid is fed from queryFn's success callback, so re-opening the
        // same row has to run the query again rather than resolve from cache.
        queryKey: ['platformNumbers', numberId, expansionCount],
        queryFn: async () => {
            if (!numberId) {
                return Promise.reject();
            }
            const data = await getPlatformNumbers(numberId, accountScope);

            const prioritisedRes = data.sort((a, b) => a.priority - b.priority);
            if (expandedParams?.successCallback) {
                expandedParams.successCallback(prioritisedRes);
            }
            expandedPlatformNumbersRef.current = prioritisedRes;
            return prioritisedRes;
        },
        enabled: Boolean(numberId),
        refetchOnWindowFocus: false,
        staleTime: 0,
    });
};

export default useGetPlatformNumbers;
